import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBrain = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M21.7819 19.5923C21.6532 22.4916 18.1515 23.0987 16.4521 21.4499C15.6488 23.0068 13.9889 22.9995 13.2594 22.8014L11.6645 26.5751C11.6479 26.6142 11.611 26.6394 11.5703 26.6394H9.32C9.26312 26.6394 9.217 26.591 9.217 26.5312V24.2339C2.39386 23.8284 3.26928 18.9543 4.94288 18.0984C1.90464 15.2064 3.91298 12.5936 4.94288 11.5575C5.32204 10.4892 6.15303 8.88172 7.98111 8.34116M27.7303 12.6953C29.3987 15.1819 28.7469 18.2267 26.4944 19.5948C24.9972 20.5043 22.8771 20.3739 21.7825 19.5948C20.6469 18.7866 20.004 17.3912 20.1089 16.2902M22.6849 7.39391C21.1161 6.46982 17.8443 4.45111 13.6732 5.82956M8.70075 10.4234C6.1523 7.07059 12.0485 2.85416 15.1985 7.5546M24.9648 15.1758C30.1659 13.8514 26.6127 4.87788 20.356 8.12128M21.6283 12.1518C20.9845 13.2059 17.5087 13.368 17.5087 10.2058M18.3581 12.3985C18.0748 13.0381 17.1376 14.2256 15.6545 13.858M13.6732 17.6715C12.8325 18.9859 9.29076 18.9295 9.16555 16.0003",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBrain;
